import { useMemo, useState } from "react";
import { Col, Collapse, Dropdown, DropdownButton, Form, Row, Spinner } from "react-bootstrap";
import { SubmitResetGenerateButton } from "../../Client/ClientUtil";
import { axiosGetWithHeader, axiosPutWithHeader, ShowGenericAlertError } from "../../Common/axios";

export function AstrologerComment ({menuArray,userData,clientData,eventData,handleEventKey,handleEventData,setErrorAlert}) {
  const [spinner, setSpinner] = useState('Loading - Astrologer Comment');
  const [comment, setComment] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);
  const [msgtitle, setMsgtitle] = useState('Error');
  const [msgbody, setMsgbody] = useState('');
  const [msgbutton, setMsgbutton] = useState('');
  const handleAlertCallback = ()=>{setErrorMessage(null);}
  const handleEvents = (key)=> {handleEventKey(key);}
  const planetloop = ["Ket","Ven","Sun","Mon","Mar","Rag","Jup","Sat","Mer"];
  const planetOrderloop = [9,6,1,2,3,8,5,7,4];

  useMemo(() => {
    if(eventData!==null && eventData.userEvent!==null && eventData.userEvent.prediction!==null
      &eventData.userEvent.prediction!==undefined
    ) {
      setComment(eventData.userEvent.prediction);
    } else {
      setComment('');
    }

    setSpinner(null);
  },[eventData]);

  function handleInput(event){
    const disallowedChars = /[&><]/g;
    const originalValue = event.target.value;
    const cleanedValue = originalValue.replace(disallowedChars, '');
    if (originalValue !== cleanedValue) {
        event.target.value=cleanedValue;
    }
    setComment(event.target.value);
  }

  function handleSubmit(event){
    const data = {
      userId:userData.id,
      eventId: eventData.currentEvent.id,
      prediction: comment,
    };
    axiosPutWithHeader("/chart/event/prediction", data,
      (response)=>{
        setMsgtitle("Comment");
        setMsgbutton("Close");
        if(response.data.code==='200') {
          handleEventData(userData.id,eventData.currentEvent.id);
          setMsgbody("Comment is updated successfully.");
        } else {
          setMsgbody("Error occurred while saving comment.");
        }
        setErrorMessage("Error");
      },
      (error)=>{
        setMsgtitle("Error");
        setMsgbody("Error occurred while saving");
        setMsgbutton("Close");
        setErrorMessage(error.message);
      }
    );      
    event.preventDefault();
  }

  function handleReset(){
    if(eventData!==null && eventData.userEvent!==null && eventData.userEvent.prediction!==null
      &eventData.userEvent.prediction!==undefined
    ) {
      setComment(eventData.userEvent.prediction);
    } else {
      setComment('');
    }
  }

  function handleGenerate(){
    axiosGetWithHeader("/chart/event/prediction/"+userData.id+"/"+eventData.currentEvent.id,
      (response)=>{
        setComment(response.data);
      },
      (error)=>{
        setErrorAlert(error.message);
      }
    );
  }

  return(<>
    {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
    { eventData===null || eventData===undefined || eventData.length===0 || userData===null || userData===undefined
          || clientData===null || clientData===undefined ?<></>:
      <Collapse in={menuArray[4]} className="m-0 p-0">
        <Row id="comment1" className="m-0 p-0">
          <Col xs={12} className="p-0 m-0 pt-1">

            <Row id="comment2" className="m-0 p-0">
              <Col xs={0} lg={3} className="m-0 p-0">
                <table class="table table-hover align-middle caption-top m-0 p-0 text-center TableFont11">
                  <caption class="m-0 p-0 ps-2 pt-2"><h5 class="m-0 p-0">Astrologer Report</h5></caption>
                </table>
              </Col>
              <Col xs={12} lg={6} className="p-0 m-0 text-center">
                <Row id="heading" className="m-0 p-0">
                  <Col xs={0} lg={3} className="p-0 m-0 text-start">
                    <DropdownButton id="dropdown-basic-button" title={eventData.currentEvent.name} variant="light" class="m-0 p-0 me-2">
                      <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                      {Object.keys(eventData.allEvents).map((key, index) => {
                        const event = eventData.allEvents[key];
                        return Object.keys(event).map((key) => {
                          const value = event[key];
                          if(key<0) {
                            return <Dropdown.Divider/>
                          }
                          return <Dropdown.Item onClick={()=>handleEvents(key)} >{value}</Dropdown.Item>
                        })  
                      })}
                      </div>
                    </DropdownButton>
                  </Col>
                  <Col xs={0} lg={9} className="p-0 pt-0 m-0">
                  <div class="input-group m-0 p-0">
                    <input type="input" maxlength="10" class="form-control" title="Primary" value={eventData.currentEvent.primary===null?"":eventData.currentEvent.primary}/>
                    <input type="input" maxlength="10" class="form-control" title="Secondary" value={eventData.currentEvent.secondary===null?"":eventData.currentEvent.secondary}/>
                    <input type="input" maxlength="10" class="form-control" title="Supportive" value={eventData.currentEvent.supportive===null?"":eventData.currentEvent.supportive} />
                    <input type="input" maxlength="10" class="form-control" title="Bad" value={eventData.currentEvent.bad===null?"":eventData.currentEvent.bad}/>
                    <input type="input" maxlength="10" class="form-control" title="worse" value={eventData.currentEvent.worse===null?"":eventData.currentEvent.worse} />
                    <input type="input" maxlength="10" class="form-control" title="Worst" value={eventData.currentEvent.worst===null?"":eventData.currentEvent.worst} />
                  </div>
                  </Col>    
                </Row>
              </Col>
              <Col xs={0} lg={3} className="m-0 p-0"></Col>
            </Row>

            <Row id="timechart1" className="m-0 p-0">
              <Col xs={0} lg={8} className="m-0 p-0 text-center">
                <Row id="time2" className="m-0 p-0 ">
                  <Col xs={12} lg={12} className="m-0 p-0 pt-1 pb-1">
                    <table class="table table-bordered table-hover align-middle caption-top m-0 p-0 text-center TableFont11">
                      <small class="Font12 ps-4" title={"Dasha Period   :"+clientData.currentDashaPeriod+"\nDasha Balance :"+clientData.currentDashaBalance}>
                        Dasha:{clientData.currentDashaName}({clientData.currentDashaStart.substring(0,10)} to {clientData.currentDashaEnd.substring(0,10)})
                      </small>
                      <small class="Font12 ps-2" title={"Bhukti Period   :"+clientData.currentBhuktiPeriod+"\nBhukti Balance :"+clientData.currentBhuktiBalance}>
                        Bhukti:{clientData.currentBhuktiName}({clientData.currentBhuktiStart.substring(0,10)} to {clientData.currentBhuktiEnd.substring(0,10)})
                      </small>
                      <small class="Font12 ps-2" title={"Andharam Period   :"+clientData.currentAndharamPeriod+"\nAndharam Balance :"+clientData.currentAndharamBalance}>
                        Andharam:{clientData.currentAndharamName}({clientData.currentAndharamStart.substring(0,10)} to {clientData.currentAndharamEnd.substring(0,10)})
                      </small>
                    </table>
                  </Col>
                </Row> 

                <form method="post" onSubmit={handleSubmit}>
                <Row id="comment2" className="m-0 p-0 ">
                  <Col xs={12} lg={12} className="m-0 p-2">
                      <Form.Control as="textarea" class="" id="comment" name="comment" rows="15" col="80" maxlength="1000" onChange={handleInput} value={comment}></Form.Control>
                  </Col>
                </Row>
                <Row id="comment2" className="m-0 p-0 ">
                  <Col xs={8} lg={6} className="m-0 p-1 text-start text-nowrap">
                   {"Characters &, < , > are not allowed"}
                  </Col>
                  <Col xs={4} lg={6} className="m-0 p-1 pe-4 text-end text-nowrap">
                  Char : {1000-comment.length}
                  </Col>
                </Row>

                <Row id="significators" className="m-0 p-0 pt-3">
                <Col xs={12} lg={3} className="m-0 p-0"></Col>
                <Col xs={12} lg={6} className="m-0 p-0 text-center">
                    <SubmitResetGenerateButton callback={handleReset} callbackGenerate={handleGenerate} /> 
                </Col>
                <Col xs={12} lg={3} className="m-0 p-0"></Col>
                </Row>

                </form> 

              </Col>
              <Col xs={0} lg={4} className="m-0 p-0 text-center">
                <Row id="time4" className="m-0 p-0 ">
                  <Col xs={12} lg={12} className="m-0 p-0 pt-1 pb-1">
                      &nbsp;
                  </Col>
                </Row>      

                <Row id="timechart2" className="m-0 p-0">
                  <Col xs={12} lg={12} className="m-0 p-1 pb-2 text-center">
                    <table class="table table-bordered table-hover align-middle caption-top p-0 m-0 text-center TableFont11">
                      <thead>
                        <tr class="m-0 p-0">
                          <th class="m-0 plittable-td">&nbsp;</th>
                          <th class="m-0 plittable-td">Destiny</th>
                          <th class="m-0 plittable-td">SubLord</th>
                          <th class="m-0 plittable-td">Result</th>
                        </tr>  
                      </thead>
                      <tbody class="m-0 p-0">
                      { eventData.supportiveDestiny===null?<></>:
                        eventData.supportiveDestiny.map((destiny,destinyIndex) => (
                        <tr class="m-0 p-0">
                          <th class={" m-0 p-1 text-start plittable-td"}>Supportive</th>
                          <td class={" m-0 p-1 text-center plittable-td"}>{destiny}</td>
                          <td class={" m-0 p-1 text-start plittable-td"}>{eventData.supportiveDestinyPlanet[destinyIndex]}</td>
                          {eventData.userEvent===null||eventData.userEvent===undefined||eventData.userEvent.supportiveDestinyCategory===null||eventData.userEvent.supportiveDestinyCategory===undefined||eventData.allPlanetCategory===undefined?
                            <td class={" m-0 p-1 text-start plittable-td text-nowrap"}>&nbsp;</td>
                            :
                            <td class={" m-0 p-1 text-start plittable-td text-nowrap"} style={{"backgroundColor":eventData.allPlanetCategory[eventData.userEvent.supportiveDestinyCategory.split(",")[destinyIndex]][2], "color":eventData.allPlanetCategory[eventData.userEvent.supportiveDestinyCategory.split(",")[destinyIndex]][3]}}>
                              {eventData.allPlanetCategory[eventData.userEvent.supportiveDestinyCategory.split(",")[destinyIndex]][0]}
                            </td>
                          }
                        </tr>  
                        ))
                      }

                      { eventData.opposingDestiny===null?<></>:
                        eventData.opposingDestiny.map((destiny,destinyIndex) => (
                        <tr class="m-0 p-0">
                          <th class={" m-0 p-1 text-start plittable-td"}>Opposive</th>
                          <td class={" m-0 p-1 text-center plittable-td"}>{destiny}</td>
                          <td class={" m-0 p-1 text-start plittable-td"}>{eventData.opposingDestinyPlanet[destinyIndex]}</td>
                          {eventData.userEvent===null||eventData.userEvent===undefined||eventData.userEvent.opposingDestinyCategory===null||eventData.userEvent.opposingDestinyCategory===undefined||eventData.allPlanetCategory===undefined?
                            <td class={" m-0 p-1 text-start plittable-td text-nowrap"}>&nbsp;</td>
                            :
                            <td class={" m-0 p-1 text-start plittable-td text-nowrap"} style={{"backgroundColor":eventData.allPlanetCategory[eventData.userEvent.opposingDestinyCategory.split(",")[destinyIndex]][2], "color":eventData.allPlanetCategory[eventData.userEvent.opposingDestinyCategory.split(",")[destinyIndex]][3]}}>
                              {eventData.allPlanetCategory[eventData.userEvent.opposingDestinyCategory.split(",")[destinyIndex]][0]}
                            </td>
                          }
                        </tr>  
                        ))
                      }
                      </tbody>
                    </table>
                  </Col>
                </Row>

                <Row id="timechart2" className="m-0 p-0">
                  <Col xs={12} lg={12} className="m-0 p-1 pb-2 text-center">
                    <table class="table table-bordered table-hover align-middle caption-top p-0 m-0 text-center TableFont11">
                      <thead>
                        <tr class="m-0 p-0">
                          <th class="m-0 plittable-td" >Planet</th>
                          <th class="m-0 plittable-td">Order</th>
                          <th class="m-0 plittable-td" >Result</th>
                          <th class="m-0 plittable-td">Combined</th>
                        </tr>  
                      </thead>
                      <tbody class="m-0 p-0">
                        {planetloop.map((value, index) => (
                          <tr class="m-0 p-0">
                            <td class={" m-0 p-1 ps-2 text-center plittable-td"} >{value}</td>
                            { eventData!==null && eventData.userEvent!==null && eventData.userEvent.planetOrder!==null
                                &eventData.userEvent.planetOrder!==undefined?  
                              <td class={" m-0 p-1 text-center plittable-td"} >{eventData.userEvent.planetOrder.split(",")[planetOrderloop[index]-1]==="0"?"":eventData.userEvent.planetOrder.split(",")[planetOrderloop[index]-1]}</td>
                              :
                              <td class={" m-0 p-1 text-center plittable-td"} ></td>
                            }
                            { eventData!==null && eventData.userEvent!==null && eventData.userEvent.planetCategory!==null
                                &eventData.userEvent.planetCategory!==undefined?  
                              <td class={" m-0 p-1 text-start plittable-td text-nowrap"} 
                              style={{"backgroundColor":eventData.allPlanetCategory[eventData.userEvent.planetCategory.split(",")[planetOrderloop[index]-1]][2], "color":eventData.allPlanetCategory[eventData.userEvent.planetCategory.split(",")[planetOrderloop[index]-1]][3]}}
                              >
                                {eventData.allPlanetCategory[eventData.userEvent.planetCategory.split(",")[planetOrderloop[index]-1]][0]}
                              </td>
                              :
                              <td class={" m-0 p-1 text-start plittable-td"} ></td>
                            }
                            { eventData!==null && eventData.userEvent!==null && eventData.userEvent.planetCombinedCategory!==null
                                &eventData.userEvent.planetCombinedCategory!==undefined?  
                              <td class={" m-0 p-1 text-start plittable-td text-nowrap"} 
                              style={{"backgroundColor":eventData.allPlanetCategory[eventData.userEvent.planetCombinedCategory.split(",")[index]][2], "color":eventData.allPlanetCategory[eventData.userEvent.planetCombinedCategory.split(",")[index]][3]}}
                              >
                                {eventData.allPlanetCategory[eventData.userEvent.planetCombinedCategory.split(",")[index]][0]}
                              </td>
                              :
                              <td class={" m-0 p-1 text-start plittable-td"} ></td>
                            }
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Col>
                </Row>

              </Col>
            </Row>

          </Col>
        </Row>
      </Collapse>
    }
    <ShowGenericAlertError errorAlert={errorMessage} setErrorAlert={setErrorMessage} msgtitle={msgtitle}
        msgbody={msgbody} msgbutton={msgbutton} callback={handleAlertCallback}/>
    
  </>
  );
}